import { ComponentProps } from "react"

import { twMerge } from "tailwind-merge"

import { buttonClassName, ButtonKind } from "./sharedClassNames"

export type ButtonAnchorProps = { kind?: ButtonKind } & ComponentProps<"a">

export function ButtonAnchor(props: ButtonAnchorProps) {
  const { className, kind = "primary", ...restProps } = props

  return <a className={twMerge(buttonClassName(kind), className)} {...restProps} />
}
